import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    getFullLabelFetchTimestamp,
    getLabelsAreStale,
    selectAllLabels,
} from '../../../../../../element/labels/labelSelectors';
import { fetchLabelsByIds, fetchLabelsFromDb } from '../../../../../../element/labels/labelsService';
import { replaceLoadedLabels, setFullLabelFetchTimestamp } from '../../../../../../../common/labels/labelActions';

type Props = {
    isActive: boolean;
};

/**
 * Keeps the labels tool backed by a complete label set on first open,
 * then refreshes known labels when access changes mark them as stale.
 */
const useLabelRefresh = ({ isActive }: Props) => {
    const dispatch = useDispatch();
    const fullLabelFetchTimestamp = useSelector(getFullLabelFetchTimestamp);
    const labelsAreStale = useSelector(getLabelsAreStale);
    const allKnownLabelsMap = useSelector(selectAllLabels);

    const doFullFetch = isActive && !fullLabelFetchTimestamp;
    const doStaleRefresh = isActive && labelsAreStale && !!fullLabelFetchTimestamp;

    useEffect(() => {
        if (!doFullFetch) return;

        fetchLabelsFromDb().then((labels) => {
            dispatch(replaceLoadedLabels(labels));
            dispatch(setFullLabelFetchTimestamp());
        });
    }, [doFullFetch]);

    useEffect(() => {
        if (!doStaleRefresh) return;

        const allKnownLabelIds = Object.keys(allKnownLabelsMap || {});
        fetchLabelsByIds(allKnownLabelIds).then((labels) => dispatch(replaceLoadedLabels(labels)));
    }, [allKnownLabelsMap, doStaleRefresh]);
};

export default useLabelRefresh;
